import axios from "axios";

async function EPAIDLetter(epaLetterID) {
    const pdf = await axios({
      url: `api/v1/hwts/search/facility/permanent-id-confirmation?epaId=${epaLetterID}`,
      method: "GET",
      responseType: "blob" // important
    });

    // export pdf
    var blob = new Blob([pdf.data], {type: "application/pdf"});
    var link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);

    var fileName = 'FAC_' + epaLetterID +'.pdf'  
    link.download = fileName;
    link.click();

  }

  export default EPAIDLetter;